import React from "react";
import ReactHtmlParser, {
  Transform,
  convertNodeToElement
} from "react-html-parser";
import Dompurify from "dompurify";

interface HTMLParserProps {
  html: string;
}

export const HTMLParser: React.FC<HTMLParserProps> = ({ html }) => {
  const transform: Transform = (node, index) => {
    if (node.type === "tag" && node.name === "iframe") {
      return (
        <div className="iframe" key={index}>
          {convertNodeToElement(node, index, transform)}
        </div>
      );
    }
  };

  const purify_config = {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling"]
  };

  const cleaned = Dompurify.sanitize(html, purify_config);

  return (
    <React.Fragment>{ReactHtmlParser(cleaned, { transform })}</React.Fragment>
  );
};
